import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { User, UserService } from '@fry/lib/users';
import { FormData } from '@fry/lib/forms';

import { UserEditForm } from '@fry/components/users/user-edit/user-edit.form';
import { SecurityService } from '@fry/lib/security';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    providers: [
        UserEditForm,
        UserService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserEditComponent implements OnInit {

  public user: User;
  public form: FormData;
  public navLinks$: Observable<any>;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private security: SecurityService,
  ) { }

  public activeTab = 1;
  private _navLinks = [
    {
      path: 'basic',
      label: $localize `Basic Information`
    },
    {
      path: 'emails',
      label: $localize `Emails`
    },
    {
      path: 'details',
      label: $localize `Additional Details`
    },
  ];

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.userService.setUser(data.user);
      this.user = data.user;
      this.navLinks$ = this.getNavLinks();
    });
  }

  getNavLinks() {
    return this.security.hasOwnPermissionFor('roles.assign', this.user.doc.user)
      .pipe(map(has => {
        const links = [...this._navLinks];
        if (has) {
          links.push({
            path: 'roles',
            label: $localize `Access Control`
          });
        }
        return links;
      }));
  }
}
